/**
 * Chunk yuklanmay qolganda sahifani BIR MARTA avtomatik qayta yuklaydi.
 *
 * Nega kerak: bundle fayl nomlarida versiya turadi (`main.v.2.1.29.4.js`), kontent-hash emas.
 * Yangi deploydan keyin eski nomdagi fayllar serverda qolmaydi, SPA fallback esa ularning
 * o'rniga `index.html` qaytaradi (HTTP 200, `text/html`). Sahifasi ochiq turgan foydalanuvchi
 * yangi bo'limga o'tganda kechiktirilgan (lazy) chunkni so'raydi va brauzer HTML ni JS deb
 * o'qishga urinadi:
 *     Uncaught SyntaxError: Unexpected token '<'
 *     ChunkLoadError: Loading chunk 2907 failed
 * Sahifani qayta yuklash yangi `index.html` ni oladi va muammo yo'qoladi.
 *
 * Halqadan himoya: qayta yuklash vaqti sessionStorage'ga yoziladi va COOLDOWN ichida
 * takrorlanmaydi. Ya'ni chunk haqiqatan buzuq bo'lsa (yangi versiyada ham yo'q bo'lsa)
 * sahifa cheksiz qayta yuklanmaydi — foydalanuvchi xatoni ko'radi.
 */

const RELOAD_MARK_KEY = "chunk-reload-at";
const RELOAD_COOLDOWN_MS = 60_000;

const readMark = (): number => {
  try {
    return Number(window.sessionStorage?.getItem(RELOAD_MARK_KEY)) || 0;
  } catch {
    // Maxfiy rejimda sessionStorage o'qish ham xato berishi mumkin.
    return 0;
  }
};

const writeMark = (value: number): void => {
  try {
    window.sessionStorage?.setItem(RELOAD_MARK_KEY, String(value));
  } catch {
    // Yozib bo'lmasa ham qayta yuklaymiz — bir martalik himoya yo'qoladi, lekin
    // brauzer sessiyasi davomida bu holat kam uchraydi.
  }
};

/** Xato aynan chunk yuklanmaganidanmi (JS yoki CSS). */
const isChunkLoadError = (value: unknown): boolean => {
  const error = value as { message?: unknown; name?: unknown } | null | undefined;
  const name = String(error?.name ?? "");
  const message = String(error?.message ?? value ?? "");

  return name === "ChunkLoadError" || /Loading (CSS )?chunk \S+ failed/i.test(message);
};

const reloadOnce = (): void => {
  const now = Date.now();
  if (now - readMark() < RELOAD_COOLDOWN_MS) {
    return;
  }
  writeMark(now);
  window.location.reload();
};

/**
 * ErrorBoundary ushlagan xato uchun: React ushlangan xatoni `window` ga chiqarmaydi, shuning uchun
 * pastdagi tinglovchi uni ko'rmaydi. Chunk xatosi bo'lsa shu yerda bir martalik qayta yuklash qilinadi.
 */
export const reloadIfChunkLoadError = (error: unknown): boolean => {
  if (!isChunkLoadError(error)) {
    return false;
  }
  reloadOnce();
  return true;
};

/** Global tinglovchilarni o'rnatadi. `index.tsx` dan bir marta chaqiriladi. */
export const registerChunkReload = (): void => {
  window.addEventListener("error", (event: ErrorEvent) => {
    if (isChunkLoadError(event.error)) {
      reloadOnce();
    }
  });

  // React.lazy import'i rad etilganda xato aynan shu yo'l bilan chiqadi.
  window.addEventListener("unhandledrejection", (event: PromiseRejectionEvent) => {
    if (isChunkLoadError(event.reason)) {
      reloadOnce();
    }
  });
};
